import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahClaimItems } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { DashboardClaimItemsResponse } from '~support-at-home/models/dashboard';

type Request = {
  limit: number;
  offset: number;
  [key: string]: unknown;
};

export const dashboardClaimItemsApi = createApi({
  reducerPath: 'dashboardClaimItemsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahClaimItems }),
  tagTypes: ['dashboard-claim-items'],
  endpoints: (builder) => ({
    getDashboardClaimItems: builder.query<DashboardClaimItemsResponse, Request>({
      query: (params) => ({
        url: '/dashboard',
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'dashboard-claim-items', id: 'LIST' }],
      transformResponse: (payload) => unwrap<DashboardClaimItemsResponse>(payload),
    }),
  }),
});

export const { useGetDashboardClaimItemsQuery } = dashboardClaimItemsApi;
